import { createAction, props } from '@ngrx/store';
import { EditionMetaData } from 'search/full-card/models/edition';

export const loadEditionsMetaData = createAction(
  '[Editions] Load Editions Metadata',
  props<{ id: string, rapido?: boolean }>(),
);

export const loadEditionsMetaDataComplete = createAction(
  '[Editions] Load Editions Metadata complete',
  props<{ data: EditionMetaData }>(),
);

export const loadEditionsMetaDataFailure = createAction(
  '[Editions] Load Editions Metadata failure',
  props<any>(),
);

